<h2>Printwerk nodig</h2>
<ng-container *ngIf="!init; else dialogContent">
  <mat-spinner color="primary" diameter="48"></mat-spinner>
</ng-container>
<ng-template #dialogContent>
  <div class="upper-space">
    <div>
      <div class="d-flex">
        <checkbox
          [text]="'Printwerk nodig'"
          [checked]="needPrintworkChecked"
          (answer)="needPrintworkChecked = $event"
        ></checkbox>
        <mat-spinner
          *ngIf="resettingPrintwork"
          class="align-registration-with-textbox"
          color="primary"
          diameter="24"
        ></mat-spinner>
        <div
          *ngIf="
            !resettingPrintwork &&
            printworkAndAtelierInfo?.mostRecentPrintRelatedRegisteredAction !=
              null
          "
          class="left-space align-registration-with-textbox strong"
        >
          <ng-container
            *ngIf="
              !printworkAndAtelierInfo.printWorkFinished;
              else fullPrintRegistration
            "
          >
            (laatste keer geprint:
            {{
              printworkAndAtelierInfo.mostRecentPrintRelatedRegisteredAction
                .date | formatDate : '__/__' : 'dd/MM'
            }})
          </ng-container>
          <ng-template #fullPrintRegistration>
            <span
              >{{
                printworkAndAtelierInfo.mostRecentPrintRelatedRegisteredAction
                  .user?.firstName
                  | personName
                    : printworkAndAtelierInfo
                        .mostRecentPrintRelatedRegisteredAction.user?.lastName
              }}
            </span>
            <span
              >{{
                printworkAndAtelierInfo.mostRecentPrintRelatedRegisteredAction
                  .date | formatDate : '__/__' : 'dd/MM'
              }}
            </span>
            <span
              class="clickable secondary-color left-space"
              (click)="resetPrintwork()"
              >X reset</span
            >
          </ng-template>
        </div>
      </div>
    </div>
    <ng-container *ngIf="needPrintworkChecked">
      <div *ngIf="soldRented != null" class="upper-space">
        <checkbox
          [text]="printStickerCheckedLabel"
          [checked]="printStickerChecked"
          (answer)="printStickerChecked = $event"
        ></checkbox>
      </div>
      <div class="upper-space">
        <label class="regular">Beschrijving printwerk</label>
        <textarea-input
          [placeholder]="'Beschrijving printwerk'"
          [initContent]="printworkExtraInfo"
          [client]="true"
          (answer)="printworkExtraInfoChanged($event)"
        >
        </textarea-input>
      </div>
    </ng-container>
    <div>
      <label class="indent">Atelier</label>
      <div class="d-flex">
        <checkbox
          [text]="'Opdracht klaarmaken door atelier'"
          [checked]="handleByAtelier"
          (answer)="handleByAtelier = $event"
        ></checkbox>
        <mat-spinner
          *ngIf="resettingAtelier"
          class="align-registration-with-textbox"
          color="primary"
          diameter="24"
        ></mat-spinner>
        <div
          *ngIf="
            !resettingAtelier &&
            (printworkAndAtelierInfo?.lastAtelierOperationAt != null ||
              printworkAndAtelierInfo?.atelierEmployeeUser != null)
          "
          class="left-space align-registration-with-textbox d-flex strong"
        >
          <div
            *ngIf="printworkAndAtelierInfo.atelierEmployeeUser != null"
            class="d-flex"
          >
            <span>{{
              printworkAndAtelierInfo.atelierEmployeeUser.firstName
                | personName
                  : printworkAndAtelierInfo.atelierEmployeeUser.lastName
            }}</span>
            <span
              class="clickable impersonate-icon"
              [matTooltip]="'Nabootsen'"
              (click)="impersonateAtelierEmployee()"
              ><mat-icon>group</mat-icon></span
            >
          </div>
          <ng-container
            *ngIf="
              !printworkAndAtelierInfo.atelierFinished;
              else fullAtelierRegistration
            "
          >
            <div
              *ngIf="printworkAndAtelierInfo.lastAtelierOperationAt != null"
              class="left-space"
            >
              (laatste bewerking in atelier:
              {{
                printworkAndAtelierInfo.lastAtelierOperationAt
                  | formatDate : '__/__' : 'dd/MM'
              }})
            </div>
          </ng-container>
          <ng-template #fullAtelierRegistration>
            <div class="left-space">
              <span
                >{{
                  printworkAndAtelierInfo.lastAtelierOperationAt
                    | formatDate : '__/__' : 'dd/MM'
                }}
              </span>
              <span
                class="clickable secondary-color left-space"
                (click)="resetAtelier()"
                >X reset</span
              >
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div *ngIf="handleByAtelier" class="upper-space indent">
      <label class="regular">Extra info voor atelier</label>
      <textarea-input
        [placeholder]="'Extra info voor atelier'"
        [initContent]="atelierExtraInfo"
        (answer)="atelierExtraInfoChanged($event)"
      >
      </textarea-input>
      <div class="flex flex-row atelier-cb">
        <checkbox
          [name]="createNewBoard"
          [checked]="createNewBoard"
          (answer)="createNewBoard = $event"
        ></checkbox>
        <label
          class="bold"
          for="createNewBoard"
          (click)="toggleCreateNewBoard()"
          >Nieuw bord aanmaken</label
        >
      </div>
      <div class="flex flex-row atelier-cb">
        <checkbox
          [name]="subBoardsRequired"
          [checked]="subBoardsRequired"
          (answer)="subBoardsRequired = $event"
        ></checkbox>
        <label
          class="bold"
          for="subBoardsRequired"
          (click)="toggleSubBoardsRequired()"
          >Tekst/onderborden nodig</label
        >
      </div>
    </div>
  </div>
  <div class="button-container">
    <ng-container *ngIf="!submitting">
      <button class="btn close-button" (click)="closeDialog()">Sluiten</button>
      <button
        mat-button
        class="summary-dialog-button confirm-button"
        (click)="confirmNeedsPrintwork()"
      >
        Opslaan
      </button>
    </ng-container>
    <ng-container *ngIf="submitting">
      <mat-spinner color="primary" diameter="48"></mat-spinner>
    </ng-container>
  </div>
</ng-template>
